import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'
import { formInputCss } from 'app/sofia/resources/theme/css'

export const Li = styled.li<any>`
  padding: 20px 0;
  display: flex;
  ${props => props.isChild && `
    padding-left: 15%;
  `}

  ${bp('lg')`
    flex-wrap: wrap;
  `}

  &:not(:first-child) {
    border-top: 1px solid ${props => props.theme.palette.general.borderColor};
  }

  .product {
    &-data {
      display: flex;
      flex: 1;

      p {
        margin: 8px 0;
      }
    }

    &-name {
      font: ${font('default', 'normal', '18px/1.2')};
      margin-bottom: 2px;
      margin-top: 5px;
      ${bp('sm')`
        font: ${font('default', 'normal', '16px/1.1')};
      `}
    }

    &-actions {
      display: flex;
      justify-content: flex-end;
      ${bp('lg')`
        width: 100%;
        justify-content: space-evenly;
        margin-top: 20px;

        > div:first-child {
          margin: auto 0;
        }
      `}
    }

    &-subscription {
      display: block;
      margin: 10px 0;
      line-height: 1.5;
    }

    &-image {
      padding: 0 30px 0 0;
      ${bp('sm')`
        padding: 0 15px 0 0;
      `}

      > a {
        display: block;
        text-decoration: none;
        border: 1px solid ${props => props.theme.palette.general.greyDark};
        ${props => bp('sm')`
          border-color: ${props.theme.palette.general.borderColor};
        `}

        > div {
          width: 110px;
          height: 110px;
          background: no-repeat 50% 50% / contain;
          ${bp('sm')`
            width: 80px;
            height: 80px;
          `}
        }
      }
    }

    &-options {
      font: ${font('default', 'normal', '14px/1')};
      color: ${props => props.theme.palette.general.grey};
      margin: 5px 0 0;

      ul {
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
      }

      li {
        &::after {
          content: '-';
          margin: 0 7px;
        }

        &:last-child {
          &::after {
            display: none;
          }
        }
      }
    }

    &-quantity {
      width: 80px;
      margin-left: 15px;

      label {
        font: ${font('default', 'bold', '14px/1')};
        display: block;
        margin-bottom: 5px;
      }

      input {
        ${formInputCss}
        height: 50px;
      }

      input::-webkit-inner-spin-button,
      input::-webkit-outer-spin-button {
        opacity: 1;
      }

      button {
        user-select: none;
        position: relative;
        display: block;
        width: 100%;
        text-align: center;
        color: ${props => props.theme.palette.primary.alphaDark};
        font: ${font('default', 'medium', '13px/1')};
        padding: 10px 10px;
        border: none;
        background: none;
        outline: 0;
        box-sizing: border-box;
        cursor: pointer;
        transition: opacity 300ms ease;

        &[disabled] {
          cursor: default;
          opacity: 0.6;
        }

        > div {
          position: absolute;
          right: 2px;
          top: 9px;
        }
      }

      .muted {
        opacity: 0.5;
        pointer-events: none;
        user-select: none;
      }

      > div.muted {
        ${formInputCss}
        height: auto;
        font-size: 14px;
        line-height: 1;
      }
    }

    &-remove {
      white-space: nowrap;
      display: flex;
      align-items: flex-start;

      svg {
        width: 8px;
        height: 8px;
        fill: ${props => props.theme.palette.general.greyDark};
        margin: 0 6px 0 0;
      }

      button {
        user-select: none;
        position: relative;
        display: block;
        width: 100%;
        text-transform: uppercase;
        text-align: left;
        color: ${props => props.theme.palette.general.greyDark};
        font: ${font('default', 'bold', '14px/1')};
        padding: 10px 0;
        border: none;
        background: none;
        outline: 0;
        box-sizing: border-box;
        cursor: pointer;
        transition: opacity 300ms ease;

        &[disabled] {
          cursor: default;
          opacity: 0.6;
        }

        > div {
          position: absolute;
          right: 2px;
          top: 9px;
        }
      }
    }

    &-subtotal {
      margin: 10px 0 0;
      font: ${font('default', 'bold', '22px/1.5')};
      ${bp('sm')`
        font: ${font('default', 'bold', '20px/1.5')};
      `}

      > .oldPrice {
        color: ${props => props.theme.palette.general.grey};
        text-decoration: line-through;
        margin: 0 5px 0 0;
      }

      > small {
        font: ${font('default', 'bold', '14px/1')};
        margin-left: 5px;
      }
    }
  }

  .subscription-label {
    margin: 0 12% 0 auto;
    ${props => props.isChild && `
      margin-right: 14%;
    `}
  }

  .starting-note {
    span {
      margin-right: 5px;
    }
  }
`
